import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

// Resolve a stored media URL for use in <img src>. Relative /api/... works same-origin.
export const mediaUrl = (u) => u || "";

// Fetch the published sections for a public page.
export function usePage(pageKey) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => {
    setLoading(true);
    api.get(`/public/pages/${pageKey}`)
      .then((r) => setPage(r.data))
      .catch(() => setPage(null))
      .finally(() => setLoading(false));
  }, [pageKey]);
  useEffect(() => { load(); }, [load]);
  return { page, sections: page?.sections || [], loading, reload: load };
}
